export const vehiclePositions = {
  filenameBase: 'vehicle_positions',
  extension: 'gtfs-realtime',
  schema: [
    {
      name: 'id',
      type: 'text',
      required: true,
      primary: true,
      index: true,
      source: 'id',
      prefix: true,
    },
    {
      name: 'bearing',
      type: 'real',
      source: 'vehicle.position.bearing',
      default: null,
    },
    {
      name: 'latitude',
      type: 'real',
      min: -90,
      max: 90,
      source: 'vehicle.position.latitude',
      default: null,
    },
    {
      name: 'longitude',
      type: 'real',
      source: 'vehicle.position.longitude',
      min: -180,
      max: 180,
      default: null,
    },
    {
      name: 'speed',
      type: 'real',
      min: 0,
      source: 'vehicle.position.speed',
      default: null,
    },
    {
      name: 'current_stop_sequence',
      type: 'integer',
      source: 'vehicle.currentStopSequence',
      default: null,
    },
    {
      name: 'trip_id',
      type: 'text',
      index: true,
      source: 'vehicle.trip.tripId',
      default: null,
      prefix: true,
    },
    {
      name: 'trip_start_date',
      type: 'text',
      index: true,
      source: 'vehicle.trip.startDate',
      default: null,
    },
    {
      name: 'trip_start_time',
      type: 'text',
      index: true,
      source: 'vehicle.trip.startTime',
      default: null,
    },
    {
      name: 'congestion_level',
      type: 'text',
      source: 'vehicle.congestionLevel',
      default: null,
    },
    {
      name: 'occupancy_status',
      type: 'text',
      source: 'vehicle.occupancyStatus',
      default: null,
    },
    {
      name: 'occupancy_percentage',
      type: 'integer',
      source: 'vehicle.occupancyPercentage',
      default: null,
    },
    {
      name: 'vehicle_stop_status',
      type: 'text',
      source: 'vehicle.vehicleStopStatus',
      default: null,
    },
    {
      name: 'vehicle_id',
      type: 'text',
      index: true,
      source: 'vehicle.vehicle.id',
      default: null,
      prefix: true,
    },
    {
      name: 'vehicle_label',
      type: 'text',
      source: 'vehicle.vehicle.label',
      default: null,
    },
    {
      name: 'vehicle_license_plate',
      type: 'text',
      source: 'vehicle.vehicle.licensePlate',
      default: null,
    },
    {
      name: 'vehicle_wheelchair_accessible',
      type: 'text',
      source: 'vehicle.vehicle.wheelchairAccessible',
      default: null,
    },
    {
      name: 'timestamp',
      type: 'text',
      source: 'vehicle.timestamp',
      default: null,
    },
    {
      name: 'created_timestamp',
      type: 'integer',
      required: true,
    },
    {
      name: 'expiration_timestamp',
      type: 'integer',
      required: true,
    },
  ],
};
